var map = {
	"./BOU/pattern.png": "8dc7",
	"./DRU/pattern.png": "cffd",
	"./FNB/pattern.png": "287e",
	"./HIM/pattern.png": "59e9",
	"./SUP/pattern.png": "660b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c0ae";